import createReactComponent from '../createReactComponent';
export default createReactComponent('clock-eight', 'ClockEight', [["path",{"d":"M12 6v6l-4 2","key":"svg-0"}],["path",{"d":"M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0","key":"svg-1"}]]);